const CONVERSATIONS_KEY = 'miralink_conversations';
const MESSAGES_KEY = 'miralink_messages';

const readJson = (key, fallback) => {
  try {
    return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback));
  } catch {
    return fallback;
  }
};

const writeJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    throw new Error('Браузер не дал сохранить данные. Проверьте cookies/localStorage и свободное место.');
  }
};

const makeId = () => {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const currentUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
};

const readUsers = () => {
  try {
    return JSON.parse(localStorage.getItem('miralink_users') || '[]');
  } catch {
    return [];
  }
};

const toPublicUser = (user) => ({
  id: user.id,
  username: user.username,
  nickname: user.nickname || null,
  avatar: user.avatar || null,
  bio: user.bio || null,
  created_at: user.created_at
});

export const chatAPI = {
  createConversation: async (token, userId) => {
    const me = currentUser();
    const otherUser = readUsers().find((user) => user.id === userId);

    if (!me || !otherUser) {
      throw new Error('Пользователь не найден');
    }

    const conversations = readJson(CONVERSATIONS_KEY, []);
    const existing = conversations.find(
      (conversation) => conversation.participants.includes(me.id) && conversation.participants.includes(userId)
    );

    if (existing) {
      return {
        ...existing,
        other_user: toPublicUser(otherUser)
      };
    }

    const now = new Date().toISOString();
    const conversation = {
      id: makeId(),
      participants: [me.id, userId],
      other_user: toPublicUser(otherUser),
      last_message: null,
      last_message_time: null,
      created_at: now,
      updated_at: now
    };

    writeJson(CONVERSATIONS_KEY, [...conversations, conversation]);
    return conversation;
  },

  getConversations: async () => {
    const me = currentUser();
    if (!me?.id) return [];

    const users = readUsers();
    return readJson(CONVERSATIONS_KEY, [])
      .filter((conversation) => conversation.participants.includes(me.id))
      .map((conversation) => {
        const otherId = conversation.participants.find((id) => id !== me.id);
        const otherUser = users.find((user) => user.id === otherId) || conversation.other_user;
        return {
          ...conversation,
          other_user: toPublicUser(otherUser)
        };
      })
      .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
  },

  sendMessage: async (token, conversationId, text, media = []) => {
    const me = currentUser();
    if (!me?.id) {
      throw new Error('Пользователь не найден');
    }

    const now = new Date().toISOString();
    const message = {
      id: makeId(),
      conversation_id: conversationId,
      sender: toPublicUser(me),
      text,
      media,
      media_meta: [],
      created_at: now
    };

    const messages = readJson(MESSAGES_KEY, {});
    messages[conversationId] = [...(messages[conversationId] || []), message];
    writeJson(MESSAGES_KEY, messages);

    const conversations = readJson(CONVERSATIONS_KEY, []).map((conversation) => {
      if (conversation.id !== conversationId) return conversation;
      return {
        ...conversation,
        last_message: text,
        last_message_time: now,
        updated_at: now
      };
    });
    writeJson(CONVERSATIONS_KEY, conversations);

    return message;
  },

  getMessages: async (token, conversationId) => {
    const messages = readJson(MESSAGES_KEY, {});
    return messages[conversationId] || [];
  }
};
